import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useEffect, useState } from 'react';
import { QuestionElements } from './QuestionElements';
import { Grid } from '@yoweb/ui/components/Grid';
import { Title, Text } from '@yoweb/ui/components/typography';
import { Box } from '@yoweb/ui/components/Box';
import { ErrorDisplay, useError } from '@yoweb/ui/components/form';
import { I_DO_NOT_KNOW_ID } from '@poplar/constants/intake';
import { StepsBottomPanel } from '@poplar/components/tasks/CreateTodoFlyout/StepsBottomPanel';
import { ResetFormOnIDoNotKnow } from './intake-form/IDoNotKnowAnswer';
import { TodoEditType } from '@poplar/types/enums';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var QuestionForm = function QuestionForm(_ref) {
  var _formikProps$values$q, _question$isOptional;

  var question = _ref.question,
      error = _ref.error,
      initialTask = _ref.initialTask,
      loadingDependentQuestion = _ref.loadingDependentQuestion,
      formikProps = _ref.formikProps,
      selectedAnswerOptionDependencies = _ref.selectedAnswerOptionDependencies,
      _ref$hideDraftBtn = _ref.hideDraftBtn,
      hideDraftBtn = _ref$hideDraftBtn === void 0 ? false : _ref$hideDraftBtn,
      submitBtnLabel = _ref.submitBtnLabel,
      setSelectedAnswerOptionDependencies = _ref.setSelectedAnswerOptionDependencies,
      onSave = _ref.onSave,
      onDirtyChange = _ref.onDirtyChange,
      onNext = _ref.onNext,
      todoEditType = _ref.todoEditType,
      onClose = _ref.onClose,
      disableUpsellBanner = _ref.disableUpsellBanner,
      allowPreviewHandoff = _ref.allowPreviewHandoff,
      taskTemplateId = _ref.taskTemplateId;

  var _useState = useState(false),
      isSavingDraft = _useState[0],
      setIsSavingDraft = _useState[1];

  var errorDisplay = useError();
  var isForRecurringQuestionEdit = todoEditType === TodoEditType.TODO_EDIT_RECURRING_QUESTION; // Bug in Formik, 'isValid' does not update between steps
  // Also `selectedAnswerOptionDependencies` is added here
  // to ensure that the form gets revalidated when its questions'
  // dependencies get updated

  useEffect(function () {
    void formikProps.validateForm(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [question, selectedAnswerOptionDependencies]);
  useEffect(function () {
    onDirtyChange === null || onDirtyChange === void 0 ? void 0 : onDirtyChange(formikProps.dirty); // Do not add onDirtyChange as a dep here, re-renders high up in parent component will cause this to overwrite this value that was changed in other callbacks.
    // This is due to how we switch slides in the CreateTodoFlyout. Its currently a synchronized in a useEffect() which can result in a re-render before this slide is unmounted and the next one is shown.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formikProps.dirty]);
  useEffect(function () {
    if (error) {
      errorDisplay.set(error);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [error]);

  var onSaveWrapper = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsSavingDraft(true);
              errorDisplay.clear();
              _context.prev = 2;
              _context.next = 5;
              return onSave === null || onSave === void 0 ? void 0 : onSave();

            case 5:
              _context.next = 11;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](2);
              errorDisplay.set();
              throw _context.t0;

            case 11:
              _context.prev = 11;
              setIsSavingDraft(false);
              return _context.finish(11);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 7, 11, 14]]);
    }));

    return function onSaveWrapper() {
      return _ref2.apply(this, arguments);
    };
  }();

  var onNextWrapper = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setIsSavingDraft(true);
              errorDisplay.clear();
              _context2.prev = 2;
              _context2.next = 5;
              return onNext === null || onNext === void 0 ? void 0 : onNext();

            case 5:
              _context2.next = 11;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](2);
              errorDisplay.set();
              throw _context2.t0;

            case 11:
              _context2.prev = 11;
              setIsSavingDraft(false);
              return _context2.finish(11);

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2, 7, 11, 14]]);
    }));

    return function onNextWrapper() {
      return _ref3.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_jsxs(Grid, {
    rowGap: "normal2",
    height: "100%",
    rows: errorDisplay.error ? 'auto 1fr' : 'auto',
    "data-testid": "question-form",
    children: [/*#__PURE__*/_jsx(ErrorDisplay, _objectSpread(_objectSpread({
      withBorder: true,
      scrollTo: true
    }, errorDisplay), {}, {
      "data-testid": "error-banner"
    })), /*#__PURE__*/_jsxs(Box, {
      display: "flex",
      justifyContent: "space-between",
      flexDirection: "column",
      height: "100%",
      children: [/*#__PURE__*/_jsxs(Grid, {
        rowGap: "normal1",
        children: [/*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(Title, {
            size: "sm",
            "data-testid": "question-title",
            children: question.title
          }), /*#__PURE__*/_jsx(Text, {
            size: "md",
            "data-testid": "question-description",
            children: question.description
          })]
        }), /*#__PURE__*/_jsx(QuestionElements, {
          question: question,
          isDisabled: Boolean((_formikProps$values$q = formikProps.values[question.id]) === null || _formikProps$values$q === void 0 ? void 0 : _formikProps$values$q[I_DO_NOT_KNOW_ID]),
          selectedAnswerOptionDependencies: selectedAnswerOptionDependencies,
          setSelectedAnswerOptionDependencies: setSelectedAnswerOptionDependencies,
          formikProps: formikProps
        }), /*#__PURE__*/_jsx(ResetFormOnIDoNotKnow, {
          question: question
        })]
      }), /*#__PURE__*/_jsx(StepsBottomPanel, {
        onSaveDraft: onSaveWrapper,
        isDraftLoading: isSavingDraft,
        isDraftDisabled: formikProps.isSubmitting || isSavingDraft,
        onSubmit: onNextWrapper,
        isSubmitDisabled: !formikProps.isValid && !((_question$isOptional = question.isOptional) !== null && _question$isOptional !== void 0 && _question$isOptional.value) || formikProps.isSubmitting || isSavingDraft,
        isSubmitLoading: formikProps.isSubmitting,
        initialTask: initialTask,
        loadingDependentQuestion: loadingDependentQuestion,
        submitBtnLabel: submitBtnLabel,
        hideDraftBtn: hideDraftBtn,
        showCancelBtn: isForRecurringQuestionEdit,
        onClose: onClose,
        saveDraftOnSubmit: isForRecurringQuestionEdit,
        disableUpsellBanner: disableUpsellBanner,
        allowPreviewHandoff: allowPreviewHandoff,
        taskTemplateId: taskTemplateId
      })]
    })]
  });
};